module.exports = __webpack_public_path__ + "static/media/country.21233c1b.xlsx";